import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ExamSubjectPopupComponent } from '../exam-subject-popup/exam-subject-popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { NgxSpinnerService } from 'ngx-spinner';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { element } from 'protractor';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
// import { TreeNode } from 'primeng/api';

interface FoodNode {
  name: string;
  code: string;
  type: string;
  icon: string
  children?: FoodNode[];
}
@Component({
  selector: 'app-exam-subject-setup',
  templateUrl: './exam-subject-setup.component.html',
  styleUrls: ['./exam-subject-setup.component.scss']
})
export class ExamSubjectSetupComponent implements OnInit {
  treeControl = new NestedTreeControl<FoodNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNode>();
  // exam - subject 
  // files1: TreeNode[];
  cols: any[];
  MustOff: [];
  courseSelectDropDown = [{
    id: "1",
    name: 'option1'
  }, {
    id: "2",
    name: 'option1'
  }, {
    id: "3",
    name: 'option1'
  }, {
    id: "4",
    name: 'option1'
  }];
  examSelectDropDown = [{
    id: "1",
    name: 'option1'
  }, {
    id: "2",
    name: 'option1'
  }, {
    id: "3",
    name: 'option1'
  }, {
    id: "4",
    name: 'option1'
  }];
  selectDropdown = [{
    id: "G",
    name: 'Group',

  }, {
    id: "S",
    name: 'Subject',

  }, {
    id: "P",
    name: 'Part',

  }, {
    id: "I",
    name: 'In-Part',

  }, {
    id: "H",
    name: 'Head',

  }];
  selectedoption = 'group'

  // exam Subject

  displayColumns = ['ExamSubjectCode', 'ExamSubjectName'];
  ExamSubjectForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  currentlyHoveredNode: any;
  editButton = false;
  Branch = false;
  treeshow = false;
  subCodeArr = [];
  subCodeUnderGroupArr = [];
  grpCodeArr = [];
  subCodeArrName = [];
  grpCodeArrName = [];
  showSubmitButton = true;
  PrintIF = false;
  ExamSubjectList: [{
    ExamSubjectCode: 1
    ExamSubjectName: "test-A",
    ExamSubjectExamName: "Test-A"
  }];
  isreadonlydel = false;
  ExamSubject: string;
  list;
  childrenData: any;
  ExamSubjectform: any;
  ExamSubjectSearchForm;
  APIService: any;
  DeleteChild = false;
  deleteButton: boolean;
  ExamSubjectCodefordelete;
  isreadonly = false;
  dialogRef: MatDialogRef<any>;
  CourseList: any;
  filteredListCourse: any;
  examList: any;
  filteredListExam: any;
  ExamList: any;
  BranchList: any;
  filteredListBranch: any;
  x: string;
  emid: any;
  filteredListMustOff: never[];
  disableExam = true;
  disableNew = true;
  selecttype = true;
  dialogRef1: MatDialogRef<any>;
  strId: any;
  filterlist: { id: string; name: string; }[];
  DrpList: any;
  filteredListOfDrp: any;
  EmId: any;
  userPermission: any;
  utp: any;
  subjectCreate = true;
  subjectUpdate = true;
  subjectDelete = true;
  SessionNo: any;
  validatepayload: any;
  isTooltipVisible = false;
  tooltipData: any[] = [];
  UserCollege
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,) {
    this.APIService = environment.serviceUrl;
    // this.dataSource.data = TREE_DATA; 
  }
  hasChild = (_: number, node: FoodNode) => !!node.children && node.children.length > 0;

  download() {
    const wwe = ['ExamSubjectCode', 'ExamSubjectName'];
    this.umsService.downloadFile(this.ExamSubjectList, 'jsontocsv', wwe);
  }

  ngOnInit(): void {
    this.editButton = false;
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');

    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        // if (element.PageName == 'Subject-setup' && element.PCreate == false) {
        //   this.subjectCreate = false;
        // }
        // if (element.PageName == 'Subject-setup' && element.PUpdate == false) {
        //   this.subjectUpdate = false;
        // }
        if (element.PageName == 'Subject-setup' && element.PDelete == false) {
          this.subjectDelete = false;
        }
      });
    }
    this.strId = '';
    window.scroll(0, 0);
    this.filterlist = [];
    this.ExamSubjectCodefordelete = 0;
    this.submitButton = true;
    this.DeleteChild = false;
    this.PrintIF = false;
    // this.getExamSubjectData();
    this.list = true;
    this.ExamSubjectForm = this.fb.group({
      course: new FormControl('', [Validators.required]),
      exam: new FormControl('', [Validators.required]),
      strId: new FormControl(''),
      new: new FormControl('')
    });

    this.cols = [
      { field: 'code', header: 'Code' },
      { field: 'name', header: 'Name' },
      { field: 'type', header: 'Type' },
    ];
    this.fetchCourse();
    this.fetchList();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
    }
    );
  }

  fetchList() {
    const payload = {};
    payload['CdType'] = 'SubM';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.DrpList = res.data;
        this.filteredListOfDrp = this.DrpList.slice();
      } else {
      }
    });
  }
  newrecord() {
    this.list = false;
  }
  submit() {
    if (this.ExamSubjectForm.invalid) {
      this.ExamSubjectForm.get('course').markAsTouched();
      this.ExamSubjectForm.get('exam').markAsTouched();
      return;
    } else {
    }

  }
  openSubjectExamPopUP(e, n, type) {
    let data = {};
    data['id'] = e;
    data['value'] = n;
    data['subCodee'] = this.subCodeArr;
    data['grpCode'] = this.grpCodeArr;
    data['subCodeUnderGroup'] = this.subCodeUnderGroupArr;
    data['subCodeName'] = this.subCodeArrName;
    data['grpCodeName'] = this.grpCodeArrName;
    data['type'] = type;
    data['branchId'] = this.ExamSubjectForm.value.strId;
    data['SubData'] = this.childrenData;
    if (type == 'delete') {
      const data = {};
      data['message'] = 'Are You Sure You Want To Delete This Record ?';
      data['title'] = 'Alert';
      data['icon'] = 'fa fa-question';
      this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        if (result === 'yes') {
          this.deletedata(n.EsId);
        } else {
          // this.ngOnInit();
        }
      });
    }
    else {
      this.dialogRef1 = this.dialog.open(ExamSubjectPopupComponent, {
        disableClose: true,
        width: "140vh",
        height: "auto",
        data,
      });
      this.dialogRef1.afterClosed().subscribe((result) => {
        this.get(this.umsService.examData)
        this.getStr(this.strId);
      });
    }

  }

  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        EsId: id,
      },
    };
    this.httpClient.delete(this.APIService + '/masters/exam-subject', options)
      .subscribe((s) => {
        this.spinner.hide();
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.get(this.umsService.examData)
          this.getStr(this.strId);
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.get(this.umsService.examData)
          this.getStr(this.strId);
        });
      });
  }

  fetchCourse() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    const payload = {};
    this.spinner.show();
    payload['LoginId'] = 0;
    payload['CgCode'] = this.UserCollege
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
      }
    },);
  }

  getList(e) {
    this.spinner.show();
    this.strId = '';
    this.fetchList();
    this.umsService.courseData = e;
    const payload = {};
    this.disableNew = true;
    this.filterlist = [];
    this.examList = [];
    this.subCodeArr = [];
    this.subCodeArrName = [];
    this.grpCodeArr = [];
    this.grpCodeArrName = [];
    this.subCodeUnderGroupArr = [];
    this.dataSource.data = [];
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredListOfDrp = [];
    payload['EmCoCode'] = e.CoCode;
    sessionStorage.setItem('CoCode', e)
    this.ExamSubjectForm.controls['exam'].setValue('')
    this.ExamSubjectForm.controls['exam'].setErrors(null);
    this.ExamSubjectForm.controls['exam'].clearValidators();
    this.ExamSubjectForm.controls['exam'].updateValueAndValidity();
    this.selecttype = true;
    // this.treeshow = false;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.dataSource.data = [];
        this.examList = res.data;
        this.spinner.hide();
        this.filteredListExam = this.examList.slice();
        this.disableExam = false;
      }
      else {
        this.dataSource.data = [];
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }
  get(e) {
    this.PrintIF = false;
    this.subCodeArr = [];
    this.subCodeArrName = [];
    this.grpCodeArr = [];
    this.grpCodeArrName = [];
    this.subCodeUnderGroupArr = [];
    this.dataSource.data = [];
    this.spinner.show();
    this.selecttype = false;
    this.filterlist = []
    this.filteredListBranch = [];
    this.filteredListOfDrp = [];
    this.umsService.examData = e;
    this.emid = e.EmId;
    this.strId = 0;
    if (e.EmStreams == "Y") {
      this.dataSource.data = [];
      this.filterlist = [];
      this.spinner.hide();
      this.Branch = true;
      this.disableNew = true;
      this.PrintIF = false;
      this.fetchBranch(e.EmId);
      // this.emid = e.EmId;
      
    }

    else {
      this.spinner.hide();
      this.Branch = false;
      this.disableNew = false;
      this.filterlist = [];
      // this.selecttype = false;
      const payload = {};
      payload['EsEmId'] = e.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        if (res.data == '') {
          this.PrintIF = false;
        }
        else if (res.data != '') {
          this.PrintIF = true;
        }

        this.fetchList();
        this.spinner.hide();
        // this.treeshow = true;
        this.filterlist = this.selectDropdown.slice();
        this.dataSource.data = res.data.children;
        this.childrenData = res.data.children;
        this.childrenData.forEach(element => {
          if (element.children.length > 0) {
            this.DeleteChild = false;
          }
          else {
            this.DeleteChild = true;
          }
        });
        this.duplicate();
      });
    }
  }

  getStr(e) {
    this.subCodeArr = [];
    this.subCodeArrName = [];
    this.grpCodeArr = [];
    this.grpCodeArrName = [];
    this.subCodeUnderGroupArr = [];
    this.dataSource.data = [];
    this.filteredListOfDrp = [];
    this.disableNew = false;
    this.strId = e.StrId;
    let payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = this.ExamSubjectForm.value.strId;
    this.umsService.examstrData = e;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      if (res.data == '') {
        this.PrintIF = false;
      }
      else if (res.data != '') {
        this.PrintIF = true;
      }
      this.fetchList();
      this.filterlist = this.selectDropdown.slice();
      this.dataSource.data = res.data.children;
      this.childrenData = res.data.children;
      this.childrenData.forEach(element => {
        if (element.children.length > 0) {
          this.DeleteChild = false
        }
        else {
          this.DeleteChild = true
        }
      });
       this.duplicate();
    });
  }

  fetchBranch(id) {
    const payload = {};
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

  print() {
    this.submitpayload = this.ExamSubjectForm.value;
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 101,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": this.emid,
      "CsNo": '',
      "PgBreak": '',
      "StrId": this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": this.submitpayload['course'] ? this.submitpayload['course'] : 0,
      "SnNo": this.SessionNo,
      "Extra1": '',
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  duplicate() {
    this.childrenData;
    this.childrenData.forEach((element) => {
      if (element.EsType == 'G') {
        this.grpCodeArr.push(element.EsCode);
        this.grpCodeArrName.push(element.EsName)
        element.children.forEach((element2) => {
          this.subCodeUnderGroupArr.push(element2.EsCode);
          this.subCodeArrName.push(element2.EsName);
        })
      }
      else if (element.EsType == 'S') {
        this.subCodeArr.push(element.EsCode);
        this.subCodeArrName.push(element.EsName);
      }
    })
  }

  checkDuplicate() {
    if (this.subCodeArrName) {

    }
  }

  validate() {
    this.validatepayload = this.ExamSubjectForm.value
    const payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = this.validatepayload['strId'] ? this.validatepayload['strId'] : 0;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      const esPassMarksS = [];
      const esPassMarksP = [];
      const esPassMarksH = [];
      res.data.children.forEach(element => {
      });

      // for (const value of this.newSelectedValues) {
      //   element.children.forEach(element2 => {
      //     if (element2.EsOpCode !== ' ') {
      //       const DupOpt = this.selectedOptions.some((item: any) => item === element2.EsOpCode);
      //       if (!DupOpt) {
      //         this.selectedOptions.push(element2.EsOpCode);
      //       }
      //     }
      //   });
      // }

    });
  }

  openMarks(data) {
    // this.showTooltip = true; // Set to true to display the tooltip
    // this.tooltipData = data;
    //  let x =  `
    //  Header 1 | Header 2 | Header 3
    //  ----------------------------
    //  Data 1   | Data 2   | Data 3
    //  Data 4   | Data 5   | Data 6
    // `
    //   return x  // Set the data to be displayed in the tooltip
  }

  showTooltip(type, data, value) {
    this.isTooltipVisible = true;
    this.currentlyHoveredNode = data;
    this.tooltipData = this.flattenData(data);
  }

  flattenData(data: any): any[] {
    return [
      {
        column1: data.EsMarkGrd,
        column2: data.EsCollUni,
        column3: data.EsMaxMarks,
        column4: data.EsPartMarks,
        column5: data.EsQMarks,
        column6: data.EsPassMarks,
        column7: data.EsExmMarks,
        column8: data.EsDistMarks,
        // Add more columns as needed
      },
      // Add more items if necessary
    ];
  }

  hideTooltip() {
    this.isTooltipVisible = false;
    this.currentlyHoveredNode = null;
  }

}


